module.exports = __webpack_public_path__ + "img/image_2.79f81fbd.png";